export default __webpack_public_path__ + "static/media/0xe20d2df5041f8ed06976846470f727295cdd4d23.7a0f01c7.webp";